import { lazy } from 'react';

// React.lazy that survives a deploy (Phase 46). Each deploy replaces the
// content-hashed chunks, so a tab opened before it can't load a page it hasn't
// visited yet: the host answers the old chunk URL with 404.html. Reloading once
// picks up the new build. The sessionStorage flag stops a reload loop when a
// chunk is genuinely broken; then the error reaches LoadErrorBoundary.
const RELOAD_FLAG = 'ia-chunk-reload';

export default function lazyPage(load) {
  return lazy(() =>
    load().then(
      (module) => {
        try {
          sessionStorage.removeItem(RELOAD_FLAG);
        } catch {
          /* storage blocked: nothing to clear */
        }
        return module;
      },
      (error) => {
        try {
          if (!sessionStorage.getItem(RELOAD_FLAG)) {
            sessionStorage.setItem(RELOAD_FLAG, '1');
            window.location.reload();
            return new Promise(() => {}); // keep the Suspense fallback up until the reload
          }
        } catch {
          /* storage blocked: let the error boundary handle it */
        }
        throw error;
      }
    )
  );
}
